import {saveAs} from 'file-saver'

export function useAssistantMessageExport() {
  function exportChartToPng(svgElement: SVGSVGElement | null, filename: string = 'chart.png') {
    if (!svgElement) return

    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')
    if (!ctx) return

    const width = svgElement.clientWidth || 800
    const height = svgElement.clientHeight || 600

    canvas.width = width
    canvas.height = height

    const svgString = new XMLSerializer().serializeToString(svgElement)
    const img = new Image()

    img.onload = () => {
      ctx.drawImage(img, 0, 0)

      canvas.toBlob((blob) => {
        if (!blob) return
        saveAs(blob, filename)
      }, 'image/png')
    }

    img.src = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svgString)))
  }

  return {
    exportChartToPng,
  }
}
